<template>
  <div class="content-wrap">
    <div class="header">
      <div class="title">Hotel Link</div>
    </div>
    <div class="content-container" style="padding: 0">
      <div class="content-box">
        <el-form ref="form" label-position="left" label-width="200px">
          <el-form-item label="Kích hoạt" style="margin-bottom: 10px">
            <el-switch
              v-model="active"
              :disabled="!checkAuth('HOTELLINK_ENABLE_SYNC_INVENTORY')"
              @change="value => changeActiveState(value)"
            />
          </el-form-item>
        </el-form>
        <h3>Cấu hình chi tiết</h3>
        <section
          ref="agGridWrapper"
          v-loading="tableLoading"
          class="section-box"
        >
          <div class="das-form-container" style="height: max-content">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">Khách sạn</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.hotelId"
                        @change="selectHotel($event)"
                      >
                        <el-option
                          v-for="hotel in hotelList"
                          :key="hotel.id"
                          :value="hotel.id"
                          :label="hotel.name"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label"></div>
                    <div class="grid-paging" style="padding: 0">
                      <div class="paging">
                        <button class="btn-prev" @click="prevHotel">
                          <span class="icon" />
                        </button>
                        <button class="btn-next" @click="nextHotel">
                          <span class="icon" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="das-form-container">
            <div class="grid-scroll mt-10">
              <GridVx
                ref="agGrid"
                :columns="columns"
                :rows="rows"
                row-selection="single"
                class="agGrid"
                :row-class-rules="rowClassRules"
                :get-row-class="getRowClass"
                :auto-size-cell="true"
                :pinned-bottom-row-data="pinnedBottomRowData"
                @selectionChanged="onSelectionChanged"
              />
            </div>

            <div
              v-if="checkAuth('HOTELLINK_CONFIG_DETAIL')"
              class="button-containers mb-0"
            >
              <button
                :disabled="selectedRows.length !== 1"
                class="btn primary small"
                @click="
                  () => {
                    dialogDetailVisible = true
                  }
                "
              >
                {{ 'Sửa' }}
              </button>
            </div>
          </div>
        </section>
      </div>
      <HotelLinkDetailDialog
        :value="dialogDetailVisible"
        :selected-row="selectedRows[0] || {}"
        @input="handleDialogInput"
        @attach-data="attachData"
      ></HotelLinkDetailDialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import HotelLinkDetailDialog from '@/views/mci/configuration/userConfig/hotel-link/components/hotelLinkDetailDialog.vue'
import paginationMixin from '@/mixins/paginationMixin'

import { getAllHotel } from '@/api/hotel'
import {
  changeStatus,
  getInfoButton,
  getListHotelLink
} from '@/api/config-service/hotel-link'

import { formatVND } from '@/utils/commonUtils'
import { checkAuthorized } from '@/utils/helper'

export default {
  components: { HotelLinkDetailDialog },
  mixins: [paginationMixin],
  data() {
    return {
      active: false,

      // data for search

      indexHotel: 0,
      hotelList: [],

      searchParams: {
        hotelId: ''
      },

      // grid
      rows: [],
      selectedRows: [],
      pinnedBottomRowData: [],
      rowClassRules: {
        warning: params => params.data?.warning == true
      },

      // section
      tableLoading: false,

      // dialog
      dialogDetailVisible: false
    }
  },

  computed: {
    columns() {
      return [
        {
          headerdesc: '',
          minWidth: 50,
          maxWidth: 50,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false,
          sortable: false
        },
        {
          headerName: 'Mã hạng phòng',
          field: 'room_level_code',
          tooltipField: 'room_level_code',
          minWidth: 250,
          maxWidth: 250,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: 'Tên hạng phòng',
          tooltipField: 'room_level_name',
          field: 'room_level_name',
          minWidth: 200,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: 'Room ID(Hotel Link)',
          tooltipField: 'room_id_hl',
          field: 'room_id_hl',
          maxWidth: 200,
          maxWidth: 200,
          wrapText: true,
          autoHeight: true,
          tooltipValueGetter: params => this.safeSlice(params.data.room_id_hl),

          valueGetter: params => this.safeSlice(params.data.room_id_hl)
        },
        {
          headerName: 'Rate Plan(Hotel Link)',
          field: 'rate_plan_list',
          cellClass: 'ag-cell-left ag-cell-wrap-text',
          wrapText: true,
          autoHeight: true,
          tooltipValueGetter: params => {
            return params.data.rate_plan_list
              ?.map(
                item =>
                  '(' +
                  this.safeSlice(item.rate_plan_id_hl) +
                  ') ' +
                  item.rate_plan_name_hl
              )
              .join('\n')
          },
          valueGetter: params => {
            return params.data.rate_plan_list
              ?.map(
                item =>
                  '(' +
                  this.safeSlice(item.rate_plan_id_hl) +
                  ') ' +
                  item.rate_plan_name_hl
              )
              .join('\n')
          }
        },
        {
          headerName: 'Độ chênh lệch',
          tooltipField: 'difference_hl',
          field: 'difference_hl',
          minWidth: 150,
          maxWidth: 150,
          wrapText: true,
          autoHeight: true
        }
      ]
    }
  },

  async mounted() {
    await this.getListHotel()
    await this.getActiveInfo()
    this.searchParams.hotelId = this.hotelList[0]?.id
    await this.fnGetListHotelLink()
  },

  methods: {
    checkAuth(name) {
      return checkAuthorized(name)
    },
    handleDialogInput(value) {
      this.dialogDetailVisible = value
    },

    getRowClass(params) {
      if (params.data?.warning == true) {
        return 'debt-report-row-' + 'warning'
      }
      return ''
    },

    onSelectionChanged(selectedRows) {
      this.selectedRows = selectedRows
    },

    // handle api call
    async fnGetListHotelLink() {
      this.tableLoading = true
      try {
        const res = await getListHotelLink(this.searchParams)
        this.rows = res.data
        // this.rows = this.rows.concat(this.rows)
        // this.rows = this.rows.concat(this.rows)
        // this.rows = this.rows.concat(this.rows)
        // this.rows = this.rows.concat(this.rows)
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        this.tableLoading = false
      }
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },

    async getActiveInfo() {
      const data = await getInfoButton()
      this.active = data.data == 'true'
    },

    prevHotel() {
      if (this.indexHotel > 0) {
        this.indexHotel -= 1
        this.searchParams.hotelId = this.hotelList[this.indexHotel]?.id
        this.attachData()
      }
    },
    nextHotel() {
      if (this.indexHotel < this.hotelList.length - 1) {
        this.indexHotel += 1
        this.searchParams.hotelId = this.hotelList[this.indexHotel]?.id
        this.attachData()
      }
    },

    safeSlice(str) {
      if (typeof str !== 'string') return ''
      return str.length >= 8 ? str.slice(0, 8) : str
    },

    async attachData() {
      this.tableLoading = true
      this.selectedRows = []
      let data = await this.fnGetListHotelLink()
      this.tableLoading = false
    },

    async changeActiveState(value) {
      await changeStatus(`${value}`)
        .then(data => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + data.message)
          })
          this.active = value
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
    }
  }
}
</script>

<style>
.ag-cell-wrap-text {
  white-space: pre-wrap !important; /* Preserve spaces and line breaks */
  word-break: break-word; /* Ensure words wrap properly */
  line-height: 1.5;
}
</style>
